<template>
  <pt-insure-info-form :insureInfoDetail="insureInfoDetail" @updateInsureInfo="updateInsureInfo" v-loading="submiting" ref="form" class="pt-insure-info-form__withData"></pt-insure-info-form>
</template>

<script>
import PtInsureInfoForm from './index'
export default {
  name: 'pt-insure-info-form__withData',
  components: {
    'pt-insure-info-form': PtInsureInfoForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  data () {
    return {
      submiting: false,
      insureInfoDetail: {}
    }
  },
  methods: {
    getInsureMaterialsDetail () {
      this.submiting = true
      this.$store.dispatch('getInsureMaterialsDetail', this.$route.params.id).then(res => {
        this.submiting = false
        this.insureInfoDetail = res
      }).catch(err => {
        this.submiting = false
        this.$message.error(err || '获取详情失败')
      })
    },
    updateInsureInfo (val) {
      this.submiting = true
      this.$store.dispatch('updateInsureInfo', val).then(res => {
        this.submiting = false
        history.go(-1)
        this.$message.success('编辑投保信息成功')
      }).catch(err => {
        this.submiting = false
        this.$message.error(err || '编辑投保信息失败')
      })
    }
  },
  created () {
    this.getInsureMaterialsDetail()
  }
}
</script>
